import { cn } from "@ds/lib/utils";
import { formatRupiah } from "@ds/lib/format";

/**
 * Money — Tabular Money Rule: setiap angka rupiah pakai tabular-nums,
 * ukuran ≥ body, kanan-align dalam tabel, tidak pernah italic/center.
 * Floor/cipher TIDAK lewat sini — angka modal tak pernah jadi Money.
 */
const sizeMap = {
  sm: "text-[0.9375rem]",
  md: "text-[1.0625rem]",
  lg: "text-xl",
  xl: "text-3xl",
} as const;

export interface MoneyProps extends React.HTMLAttributes<HTMLSpanElement> {
  value: number;
  /** Tampilkan "Rp". */
  symbol?: boolean;
  size?: keyof typeof sizeMap;
  /** Warnai negatif (danger) / positif (success) — selalu disertai tanda −/+. */
  colorSign?: boolean;
  muted?: boolean;
}

export function Money({
  value,
  symbol = false,
  size = "md",
  colorSign = false,
  muted = false,
  className,
  ...props
}: MoneyProps) {
  const negative = Math.round(value) < 0;
  return (
    <span
      className={cn(
        "font-semibold tabular-nums tracking-tight whitespace-nowrap",
        sizeMap[size],
        muted && "text-muted",
        colorSign && negative && "text-danger",
        colorSign && !negative && value !== 0 && "text-success",
        className,
      )}
      {...props}
    >
      {formatRupiah(value, { symbol })}
    </span>
  );
}
